import { useDispatch } from 'react-redux';
import { AddAlert, Button } from '../../../../../../component';
import { useTypedSelector } from '../../../../../../hooks/useTypedSelector';
import {
  modalOpen,
  setDisplayStudyCreationGuide,
} from '../../../../redux/dashboardActions';
import nls from '../../../nls/pt-BR.json';
import { GuideStepsKeys, Step } from '../../../redux/studies.model';
import { studiesSelector } from '../../../redux/studies.reducer';

export const handleClickExitStudyCreationGuide =
  (currentStep: Step, initialStep: GuideStepsKeys | null) =>
  (dispatch: any) => {
    if (!initialStep) {
      dispatch(modalOpen('confirm exit study creation guide'));
      return;
    }
    if (currentStep.name !== initialStep)
      dispatch(AddAlert('success', 'Alterações salvas com sucesso', 9999999));
    dispatch(setDisplayStudyCreationGuide(false));
  };

export const ExitGuideButton: React.FC = () => {
  const dispatch = useDispatch();
  const { initialStep, currentStep } = useTypedSelector(studiesSelector);
  const handleClickExit = () => {
    dispatch(handleClickExitStudyCreationGuide(currentStep, initialStep));
  };
  return (
    <Button
      cy="StudyCreationGuideExit"
      className="link normal danger"
      style={{ textDecoration: 'underline' }}
      onClick={handleClickExit}
    >
      {nls.studyCreationGuide.buttons.exit}
    </Button>
  );
};
